<template>
    <div class="l-row l-row--center">
        <div class="l-row__column l-row__column--11">
            <div class="o-dashboardCompany a-mobile">
                <div class="l-row">
                    <div class="l-row__column">
                        <p
                            class="a-price a-price--left a-text--bold a-price--big"
                            id="cards"
                        >
                            Adresy
                        </p>
                    </div>
                </div>
                <div class="l-row">
                    <div
                        v-for="address in addresses"
                        class="l-row__column"
                        :key="address.id"
                    >
                        <p class="a-label">Nazwa</p>
                        <p class="a-text">
                            {{ address.client_name }}
                        </p>
                        <p class="a-text">{{ address.address }}</p>
                        <br />
                        <p class="a-label">Osoba kontaktowa</p>
                        <p class="a-text">
                            {{ address.address_contact.first_name }}
                            {{ address.address_contact.last_name }}
                        </p>
                        <p class="a-label">email:</p>
                        <p class="a-text">
                            {{ address.address_contact.email }}
                        </p>
                        <p class="a-label">
                            tel:
                        </p>
                        <p class="a-text">
                            {{ address.address_contact.phone }}
                        </p>
                    </div>
                </div>
            </div>
            <dashboard-password></dashboard-password>
        </div>
    </div>
</template>

<script>
import DashboardPassword from '@/components/dashboard/DashboardPassword'
export default {
    components: {
        DashboardPassword
    },
    computed: {
        addresses() {
            return this.$store.getters['companies/addresses']
        },
        customer() {
            return this.$store.getters['customer/customer']
        },
        cards() {
            return this.$store.getters['clientPayments/cards']
        },
        cardsStatus() {
            return this.$store.getters['clientPayments/cardsStatus']
        },
        cardsPaginationTotal() {
            return this.$store.getters['clientPayments/cardsPaginationTotal']
        }
    },
    methods: {
        fetchCards() {
            return this.$store.dispatch('clientPayments/fetchCards')
        },
        fetchAddresses() {
            return this.$store.dispatch('companies/fetchAddresses')
        },
        setPage(page) {
            this.$store.dispatch('clientPayments/setListPage', page)
            this.fetchOffers().then(() => {
                // scroll to invoices
                this.$scrollTo('#cards', 500, {
                    offset: -110
                })
            })
        }
    },
    created() {
        this.fetchAddresses()
    }
}
</script>
